export default "__VITE_ASSET__2bad23f8__"